module.exports = {
	"id": "BW",
	"name": "Botswana",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": 0.011426,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.039991,
			"12": 0.005713,
			"13": 0.022852,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.028565,
			"19": null,
			"20": null,
			"21": 0.005713,
			"22": 0.005713,
			"23": null,
			"24": null,
			"25": 0.011426,
			"26": 0.034278,
			"27": 0.022852,
			"28": 0.011426,
			"29": 0.239946,
			"30": 0.028565,
			"31": 0.039991,
			"32": 0.051417,
			"33": 0.034278,
			"34": 0.022852,
			"35": 0.028565,
			"36": 0.039991,
			"37": 0.028565,
			"38": 0.022852,
			"39": 0.045704,
			"40": 0.091408,
			"41": 0.017139,
			"42": 0.045704,
			"43": 0.451327,
			"44": 0.028565,
			"45": 0.11426,
			"46": 0.039991,
			"47": 0.085695,
			"48": 0.05713,
			"49": 0.731264,
			"50": 0.11426,
			"51": 0.656995,
			"52": 0.605578,
			"53": 16.744803,
			"54": 4.153351,
			"55": 0.074269,
			"56": 0.028565,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.017139,
			"4": 0.017139,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.039991,
			"11": 0.022852,
			"12": 0.022852,
			"13": 0.011426,
			"14": 0.011426,
			"15": 0.051417,
			"16": 0.028565,
			"17": null,
			"18": 0.611291,
			"19": 0.022852,
			"20": 0.079982,
			"21": 0.011426,
			"22": null,
			"23": 0.097121,
			"24": null,
			"25": 0.011426,
			"26": 0.011426,
			"27": 0.554161,
			"28": 0.011426,
			"29": 0.325641,
			"30": 0.028565,
			"31": 0.062843,
			"32": 0.017139,
			"33": 0.022852,
			"34": 0.696986,
			"35": 0.11426,
			"36": 0.022852,
			"37": 0.068556,
			"38": 0.251372,
			"39": 0.108547,
			"40": 0.182816,
			"41": 0.125686,
			"42": 0.17139,
			"43": 0.439901,
			"44": 0.605578,
			"45": 0.154251,
			"46": 0.268511,
			"47": 0.931219,
			"48": 0.925506,
			"49": 6.130049,
			"50": 0.639856,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.045704
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": 0.028565,
			"18": 0.017139,
			"19": 0.011426,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.017139,
			"37": 0.034278,
			"38": 0.011426,
			"39": 0.034278,
			"40": 0.759829,
			"41": 0.074269,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.005713,
			"5": 0.028565,
			"6": 0.039991,
			"7": 0.017139,
			"8": 0.108547,
			"9": 0.17139,
			"10": 0.348493,
			"3.1": 0.034278,
			"3.2": null,
			"5.1": 0.097121,
			"6.1": null,
			"7.1": 0.022852,
			"9.1": 0.331354
		},
		"ios_saf": {
			"8": 0,
			"10": 1.19274620233,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0321431299958,
			"8.1-8.4": 0.0593830706703,
			"9.0-9.2": 0.0283295383014,
			"9.3": 0.432207058701
		},
		"android": {
			"3": 0,
			"4": 0.100417713178,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0125522141473,
			"4.1": 0.362221036822,
			"4.2-4.3": 0.905552592054,
			"4.4": 2.07649485465,
			"4.4.3-4.4.4": 2.09442658915
		},
		"ie": {
			"6": 0.0114701584541,
			"7": 4.20954815266,
			"8": 1.8868410657,
			"9": 0.64232887343,
			"10": 0.567772843478,
			"11": 4.55365290628,
			"5.5": null
		},
		"op_mob": {
			"0": 0.774584293508,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0215162303752
		},
		"edge": {
			"12": 0.474179,
			"13": 0.902654,
			"14": 0.245659
		},
		"ie_mob": {
			"10": 0.341510873239,
			"11": 1.39043712676
		},
		"bb": {
			"7": 0.372969,
			"10": null
		},
		"samsung": {
			"0": 3.288129
		},
		"and_uc": {
			"0": 3.133797
		},
		"op_mini": {
			"0": 10.4358394761
		},
		"and_chr": {
			"0": 13.338845
		},
		"and_ff": {
			"0": 1.766244
		}
	},
	"total": 96.645227
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BW.json
 ** module id = 486
 ** module chunks = 0
 **/